<template lang="pug">
  managementPage.scrollable(:title="$t(`${baseTranslationPath}.title`)"
                  @fetchData="loadList"
                  :searchPageSize="searchPageSize",
                  :showTotals="true"
                  :teamFilter="false"
                  :pagination="pagination"
                  :creatable="false"
                  ref="managementPage")
      router-view(v-slot:editor)
      template(v-slot:body)
        aiq-table.manage-documents-scrollbar(:data="items" :default-sort="defaultSortOrder" v-loading="loading")
          aiq-table-column(:label="$t(`${baseTranslationPath}.name`)"
                              label-class-name="is-bordered"
                              min-width="40"
                              :sort-method="onSortTitle"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ scope.row.rule_name }}
          aiq-table-column(:label="$t(`${baseTranslationPath}.document`)"
                          label-class-name="is-bordered"
                          min-width="60")
                template(v-slot:default="scope")
                   span {{ getDocName(scope.row) }}
          aiq-table-column(:label="$t(`${baseTranslationPath}.current_stage`)"
                          label-class-name="is-bordered"
                          min-width="40")
                template(v-slot:default="scope")
                   span {{ scope.row.stage_name }}
          aiq-table-column(prop="created_at"
                          :label="$t(`${baseTranslationPath}.created_at`)"
                          label-class-name="is-bordered"
                          min-width="50"
                          :sortable="true"
                          :sort-method="onSortTime('document.created_at')")
                template(v-slot:default="scope")
                   span {{ getItemTime(scope.row, 'document.created_at') }}
          aiq-table-column(prop="updated_at"
                          :label="$t(`${baseTranslationPath}.updated_at`)"
                          label-class-name="is-bordered"
                          min-width="50"
                          :sortable="true"
                          :sort-method="onSortTime('document.updated_at')")
                template(v-slot:default="scope")
                   span {{ getItemTime(scope.row, 'document.updated_at') }}
          aiq-table-column(v-if="canView('/settings/smart_control/:number')"
                          align="center"
                          label-class-name="is-bordered"
                          width="71")
            template(v-slot:default="scope")
              aiq-button(link type="primary" size="small", @click="openEditor(scope.row)") View
</template>

<script>
import get from 'lodash/get';
import { mapState } from 'vuex';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import { PAGINATION_DEFAULT } from '@/constants/pagination';
import dayjs from '@/localPlugins/dayjs';

const SEARCH_PAGE_SIZE = 25;


export default {
  name: 'ControlList',
  components: {
    ManagementPage,
  },
  data() {
    return {
      loading: true,
      pagination: PAGINATION_DEFAULT,
      searchPageSize: SEARCH_PAGE_SIZE,
      isHovered: null,
      defaultSortOrder: { prop: 'updated_at', order: 'descending' },
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
    };
  },
  computed: {
    ...mapState({
      items: state => state.smartControl.smartControlList,
    }),
  },
  methods: {
    async loadList({ searchTerm, searchOffset }) {
      const params = {
        limit: this.searchPageSize,
        query: searchTerm,
        offset: searchOffset,
      };

      const response = await this.$store.dispatch(
        'smartControl/getSmartControlList',
        [params, searchOffset === 0],
      );
      this.loading = false;
      this.pagination = get(response, 'data.pagination', PAGINATION_DEFAULT);
      return response;
    },

    getDocName(item) {
      return get(item, 'document.name', '');
    },
    getItemTime(item, field) {
      const time = get(item, field, '');
      return dayjs(time).format('YYYY-MM-DD HH:mm A');
    },

    openEditor(item) {
      const id = get(item, 'document.id');
      const path = `${this.$route.path}/${id}`;
      this.$router.push({
        path,
      });
    },
    onSortTitle(a, b) {
      const aValue = a.name.toLowerCase().replace(/\s+/g, '');
      const bValue = b.name.toLowerCase().replace(/\s+/g, '');
      return aValue < bValue ? 1 : -1;
    },
    onSortTime(field) {
      return (a, b) => {
        const aVal = get(a, field, '');
        const bVal = get(b, field, '');
        return aVal <= bVal ? 1 : -1;
      };
    },
  },
};
</script>